<fieldset>
  <legend class="keyLabel">{{ fieldLabel() }}</legend>
  <div class="content">
    @if (response().Horsepower) {
      <div class="detailRow">
        <label class="displayLabel">HP:</label>
        <label class="displayValue">{{ horsepowerDescription() }}</label>
      </div>
    }
    @if (response().DriveCode) {
      <div class="detailRow">
        <label class="displayLabel">Code:</label>
        <label class="displayValue">{{ response().DriveCode }}</label>
      </div>
    }
    @if (response().NumberOfTurns) {
      <div class="detailRow">
        <label class="displayLabel">Turns:</label>
        <label class="displayValue">{{ response().NumberOfTurns | number: '1.0-2' }}</label>
      </div>
    }
    @if (response().BrakingHorsepower) {
      <div class="detailRow">
        <label class="displayLabel">BHP:</label>
        <label class="displayValue">{{ response().BrakingHorsepower }}</label>
      </div>
    }
    @if (response().RevolutionsPerMinute) {
      <div class="detailRow">
        <label class="displayLabel">RPM:</label>
        <label class="displayValue">{{ response().RevolutionsPerMinute }}</label>
      </div>
    }
  </div>
</fieldset>
